<router-outlet></router-outlet>
<ng-container *ngIf="commonService.globalLodding$|async">
  <ao-loadding></ao-loadding>
</ng-container>
